// extracted by mini-css-extract-plugin
export default {"auth-aside":"auth-aside_auth-aside__o8wYF","tagline":"auth-aside_tagline__qawjV","text":"auth-aside_text__y4i8I","brand-text-underline":"auth-aside_brand-text-underline__L3E1f"};